const FormLabel = {
  baseStyle: {
    fontSize: "body.s"
  },
  variants: {
    gray: {
      color: "gray.500"
    },
    heading: {
      color: "pureBlack",
      fontSize: "heading.xl"
    }
  },
  defaultProps: {
    variant: "gray"
  }
};

export default FormLabel;